import React, {useRef, useEffect} from 'react';

import {SliderProps} from "./slider";
import {SliderCard} from "./slider-card";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {SliderEmptyState} from "./slider-empty-state";
import classNames from 'classnames';
import styles from '../style/slider.module.scss';
import {SLIDER} from "../slider.consts";

export const SliderMobile = ({
                               isRtl,
                               initialIndex,
                               id,
                               emptyStateText,
                               items,
                               height,
                               CardComponent,
                               cardComponentProps,
                               hasOdds,
                               shouldRenderOverCardArrow,
                               theme,
                               cardClassName
                             }: SliderProps) => {
  const ref = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    const cardWidth = cardRef.current?.getBoundingClientRect().width;
    ref.current.scrollLeft = (isRtl ? -1 : 1) * (initialIndex * cardWidth);
  }, [id, initialIndex]);


  const emptyStateProps = {
    text: emptyStateText,
    className: classNames(styles.slider_widget_empty_state_mobile)
  };

  return (
    <div
      className={classNames(styles.slider_widget_mobile_container, {[styles.slider_container_has_odds]: hasOdds}, {[styles.over_card_arrows]: shouldRenderOverCardArrow})}
      ref={ref}>
      {
        items?.map((item: BaseViewModel, index: Number) => (
          <div key={item.id || index} ref={cardRef}>
            <SliderCard height={height} isRtl={isRtl} isFirst={index === 0 && theme !== SLIDER.THEMES.diagonal}
                        isLast={index === items?.length - 1} className={cardClassName}>
              <CardComponent {...cardComponentProps} item={item} key={item.id} isSmallView={true} index={index}/>
            </SliderCard>
          </div>
        ))
      }
      {
        emptyStateText && <SliderEmptyState {...emptyStateProps}/>
      }
    </div>
  )
};
